import { NgxsModuleOptions, NoopNgxsExecutionStrategy } from '@ngxs/store';
import { environment } from 'src/environments/environment';

export const ngxsConfig: NgxsModuleOptions = {
  developmentMode: !environment.MSPOS_IS_DEPLOYED_BUILD,
  /*selectorOptions: {
    // These Selector Settings are recommended in preparation for NGXS v4
    // (See above for their effects)
    suppressErrors: false,
    injectContainerState: false
  },
  compatibility: {
    strictContentSecurityPolicy: true
  },
  */
  // Execution strategy overridden for illustrative purposes
  // (only do this if you know what you are doing)
  executionStrategy: NoopNgxsExecutionStrategy
};
